import { Navigate, Outlet } from "react-router-dom"
import { useAuth } from "./AuthProvider"

export const PublicRoutes = () => {
    const { user } = useAuth();
    return user? <Navigate to="/dashboard" replace /> : <Outlet />
}